var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.173 16.2193L37.6528 8.85903C36.1661 6.8768 33.3899 6.40124 31.3282 7.77567L18.499 16.3285",
    fill: "#F25926"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.173 16.2193L37.6528 8.85903C36.1661 6.8768 33.3899 6.40124 31.3282 7.77567L18.499 16.3285",
    stroke: "#F25926",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1727 26.8328H49.0084C50.2976 26.8328 51.3427 27.878 51.3427 29.1672V36.1701C51.3427 37.4593 50.2976 38.5044 49.0084 38.5044H43.1727C39.9497 38.5044 37.3369 35.8916 37.3369 32.6686V32.6686C37.3369 29.4456 39.9497 26.8328 43.1727 26.8328V26.8328Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0087 26.8328V22.1642C49.0087 18.9412 46.3959 16.3285 43.1729 16.3285H12.827C9.60397 16.3285 6.99121 18.9412 6.99121 22.1642V43.173C6.99121 46.396 9.60397 49.0087 12.827 49.0087H43.1729C46.3959 49.0087 49.0087 46.396 49.0087 43.173V38.5044",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.87cccf67ac9c85972c130006c537fe9c.svg";
export { ForwardRef as ReactComponent };